import styled from 'styled-components';
import { CardProps } from './types';

const CardStyle = styled.li`
  padding-left: 0;
  list-style-type: none;
`;

export const Card = ({ children, ...props }: CardProps) => {
  return (
    <CardStyle data-test="Card" {...props}>
      {children}
    </CardStyle>
  );
};

export default Card;
